import React, { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { blockImplicitFormSubmitOnEnter } from '../../utils/formKeyHandlers';
import { invoiceNumberCorrelativo } from './invoiceNumberUtils';

function estadoDestino(row) {
  if (!row?.tiene_invoice) return null;
  return row.estado === 'factura' ? 'prefactura' : 'factura';
}

function etiquetaEstado(estado) {
  return estado === 'factura' ? 'factura' : 'prefactura';
}

const InvoiceFacturaConfirmModal = ({ show, row, onClose, onConfirm, loading }) => {
  const destino = estadoDestino(row);
  const origen = row?.estado;
  const esCambioAFactura = destino === 'factura';
  const esVolverAPrefactura = destino === 'prefactura';
  const titulo =
    destino === 'prefactura' ? 'Volver a prefactura' : 'Cambiar a factura';
  const [numeroInvoice, setNumeroInvoice] = useState('');

  useEffect(() => {
    if (!show || !row) {
      setNumeroInvoice('');
      return;
    }
    if (esVolverAPrefactura) {
      setNumeroInvoice(invoiceNumberCorrelativo(row.numero_invoice));
    } else {
      setNumeroInvoice('');
    }
  }, [show, row, esVolverAPrefactura]);

  const numeroValido = !esCambioAFactura || numeroInvoice.trim().length > 0;

  const handleConfirm = () => {
    if (!destino || !numeroValido) return;
    onConfirm(numeroInvoice.trim());
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{titulo}</Modal.Title>
      </Modal.Header>
      <Modal.Body onKeyDown={blockImplicitFormSubmitOnEnter}>
        {row && destino ? (
          <>
            <p className="mb-0">
              ¿Confirma cambiar la invoice de <strong>{etiquetaEstado(origen)}</strong> a{' '}
              <strong>{etiquetaEstado(destino)}</strong>?
            </p>
            <Form.Group className="mt-3 mb-0">
              <Form.Label className="mb-1">N° Invoice</Form.Label>
              <Form.Control
                type="text"
                value={numeroInvoice}
                onChange={(e) => setNumeroInvoice(e.target.value)}
                placeholder={
                  esVolverAPrefactura
                    ? 'Opcional — dejar vacío para sin número'
                    : 'Correlativo de factura'
                }
                disabled={loading}
                autoFocus
              />
              {esVolverAPrefactura ? (
                <Form.Text className="text-muted">
                  Puede conservar, modificar o dejar en blanco el N° de invoice.
                </Form.Text>
              ) : null}
            </Form.Group>
            <p className="text-muted small mt-2 mb-0">Esta acción actualiza el estado del registro.</p>
          </>
        ) : (
          <p className="mb-0 text-muted">No hay invoice para cambiar el estado.</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} disabled={loading}>
          Cancelar
        </Button>
        <Button
          variant="primary"
          onClick={handleConfirm}
          disabled={loading || !destino || !numeroValido}
        >
          {loading ? 'Guardando…' : 'Confirmar'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default InvoiceFacturaConfirmModal;
export { estadoDestino };
